// extracted by mini-css-extract-plugin
module.exports = {"Padded":"Padded--2RXN0","Bordered":"Bordered--87cIL","HeaderWrapper":"HeaderWrapper--1Ynp4"};